// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import { getSenseMedia } from '~/core/api/honeycomb/index';
import { alerts as alertConstants, feedback as feedbackConstants } from '~/core/constants/';
import { requestAlert } from '~/core/state/alerts/actions';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import * as actions from './actions';
import * as constants from './constants';

export function* getData({ payload: { mediaId } }: { payload: { mediaId: string } }): Generator<*, *, *> {
    const [{ media = [] }, error] = yield call(handleApi(getSenseMedia), mediaId);

    if (!media.length || error) {
        return yield put(requestAlert(feedbackConstants.generic.UNEXPECTED_ERROR, alertConstants.types.ERROR));
    }

    const data = media[0].downloadUrl || '';

    if (!data) {
        return yield put(requestAlert(feedbackConstants.generic.UNEXPECTED_ERROR, alertConstants.types.ERROR));
    }

    yield put(actions.audioDataReceived({ data }));
}

function* watchGetData(): Generator<*, *, *> {
    yield takeLatest(constants.GET_AUDIO_DATA, handleSaga(getData));
}

export default [watchGetData];



// WEBPACK FOOTER //
// ./src/core/state/ui/sensor-logs/audio-player/sagas.js